export default __webpack_public_path__ + "static/media/lakasvalaszto.b3b19515.jpg";